import React from 'react';
import { Modal, Card, CardHeader, CardBody, CardFooter, Button } from 'reactstrap';
import api from './../../../Api.js';
import ReactStars from 'react-rating-stars-component';
import { ClipLoader } from 'react-spinners';

class ModalEvaluation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      students: [],
      evaluation: [],
      evaluationlist: [],
      load1: false,
      load2: false,
      load3: false,
      selectedUserId: null,
      selectedEvaluationId: null,
      observationDraft: '',
      savingObservation: false,
      observationMock: 'Campo de observação (mock) - aqui você pode anotar observações para o aluno.',
      inputMode: {},
      unitName: null
    };

    this.getStudents = this.getStudents.bind(this);
    this.getEvaluation = this.getEvaluation.bind(this);
    this.list_evaluationlist_unit = this.list_evaluationlist_unit.bind(this);
    this.toggleInputMode = this.toggleInputMode.bind(this);
    this.handleNumberChange = this.handleNumberChange.bind(this);
    this.loadUnitName = this.loadUnitName.bind(this);
  }

  toggleInputMode(evId) {
    this.setState(prev => {
      const m = Object.assign({}, prev.inputMode || {});
      m[evId] = m[evId] === 'number' ? 'stars' : 'number';
      return { inputMode: m };
    });
  }

  handleNumberChange(evId, rawValue) {
    const { selectedUserId } = this.state;
    if (!selectedUserId) return;
    let v = parseInt(rawValue, 10);
    if (isNaN(v)) v = 0;
    if (v < 0) v = 0;
    if (v > 5) v = 5;

    this.setState(prev => {
      const evlist = Array.isArray(prev.evaluationlist) ? prev.evaluationlist.slice() : [];
      const idx = evlist.findIndex(x => String(x.user) === String(selectedUserId) && String(x.evaluation) === String(evId));
      if (idx >= 0) {
        evlist[idx] = Object.assign({}, evlist[idx], { score: v });
      } else {
        evlist.push({ user: selectedUserId, evaluation: evId, score: v });
      }
      return { evaluationlist: evlist };
    });

    this.handleSaveScore(selectedUserId, evId, v, (this.state.selectedEvaluationId === evId) ? this.state.observationDraft : undefined);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.data?.unit !== prevProps.data?.unit) {
      this.loadUnitName();
    }
    if (this.state.selectedUserId !== prevState.selectedUserId || this.state.selectedEvaluationId !== prevState.selectedEvaluationId || this.state.evaluationlist !== prevState.evaluationlist) {
      const { selectedUserId, selectedEvaluationId } = this.state;
      if (selectedUserId && selectedEvaluationId) {
        const obs = this.getObservation(selectedUserId, selectedEvaluationId);
        if (obs !== this.state.observationDraft) {
          this.setState({ observationDraft: obs });
        }
      }
    }
  }

  componentDidMount() {
    this.getStudents();
    this.getEvaluation();
    this.list_evaluationlist_unit();
    this.loadUnitName();
  }

  async loadUnitName() {
    try {
      const unitId = this.props.data?.unit;
      if (!unitId) { this.setState({ unitName: null }); return; }
      const res = await api.getUnits(unitId);
      const unitData = res && res.data ? res.data : null;
      const name = (unitData && (unitData.name || unitData.title)) ? (unitData.name || unitData.title) : String(unitId);
      this.setState({ unitName: name });
    } catch (e) {
      console.error('Erro ao carregar nome da unit', e);
      this.setState({ unitName: String(this.props.data?.unit || '') });
    }
  }

  getStudents() {
    api.evaluationlist_unit_user_simple(this.props.classroom).then((response) => {
      const students = response.data || [];
      this.setState({ load1: true, students, selectedUserId: (students[0] && students[0].id) || null });
    }).catch((err) => {
      console.error(err);
      window.swal.fire('Ops!', 'Não foi possível carregar as lista de usuários.', 'error');
    });
  }

  getEvaluation() {
    api.evaluationlist_unit().then((response) => {
      const evs = response.data || [];
      this.setState({ load2: true, evaluation: evs, selectedEvaluationId: (evs[0] && evs[0].id) || null });
    }).catch((err) => {
      console.error(err);
      window.swal.fire('Ops!', 'Não foi possível carregar a lista de avaliação', 'error');
    });
  }

  list_evaluationlist_unit() {
    api.list_evaluationlist_unit(this.props.classroom, this.props.data.unit).then((response) => {
      this.setState({ load3: true, evaluationlist: response.data || [] });
    }).catch((err) => {
      console.error(err);
      window.swal.fire('Ops!', 'Não foi possível carregar a lista de avaliação dos usuários', 'error');
    });
  }

  findEvaluation(user, evaluation) {
    const found = (this.state.evaluationlist || []).find(x => String(x.user) === String(user) && String(x.evaluation) === String(evaluation));
    return found || null;
  }

  getScore(user, evaluation) {
    const f = this.findEvaluation(user, evaluation);
    return f ? (typeof f.score === 'number' ? f.score : parseInt(f.score || 0, 10) || 0) : 0;
  }

  getObservation(user, evaluation) {
    const f = this.findEvaluation(user, evaluation);
    return f ? (f.observation || '') : '';
  }

  handleSelectUser(id) {
    this.setState({ selectedUserId: id });
  }

  handleSaveScore(userId, evaluationId, score) {
    const observation = arguments.length >= 4 ? arguments[3] : undefined;

    this.setState(prev => {
      const evlist = Array.isArray(prev.evaluationlist) ? prev.evaluationlist.slice() : [];
      const idx = evlist.findIndex(x => String(x.user) === String(userId) && String(x.evaluation) === String(evaluationId));
      if (idx >= 0) {
        evlist[idx] = Object.assign({}, evlist[idx], { score, ...(observation !== undefined ? { observation } : {}) });
      } else {
        evlist.push({ user: userId, evaluation: evaluationId, score, ...(observation !== undefined ? { observation } : {}) });
      }
      return { evaluationlist: evlist };
    });

    const payload = { user: userId, evaluation: evaluationId, classroom: this.props.classroom, unit: this.props.data.unit, score };
    if (observation !== undefined) payload.observation = observation;

    api.post_evaluationlist_unit(payload)
      .then(() => {
        this.list_evaluationlist_unit();
      })
      .catch(err => {
        console.error('Erro ao salvar avaliação', err);
        window.swal.fire('Ops!', 'Não foi possível salvar a avaliação.', 'error');
      });
  }

  saveCurrentObservation() {
    const { selectedUserId, selectedEvaluationId, observationDraft } = this.state;
    if (!selectedUserId || !selectedEvaluationId) return;
    this.setState({ savingObservation: true });
    const score = this.getScore(selectedUserId, selectedEvaluationId);
    this.handleSaveScore(selectedUserId, selectedEvaluationId, score, observationDraft);
    setTimeout(() => this.setState({ savingObservation: false }), 600);
  }

  renderLeftList() {
    const { students, selectedUserId } = this.state;
    return (
      <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 8 }}>
        <ul className="list-group">
          {students.map(s => (
            <li key={s.id} className={`list-group-item list-group-item-action ${String(s.id) === String(selectedUserId) ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => this.handleSelectUser(s.id)}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="font-weight-600">{s.name} {s.lastName}</div>
                  <div className="text-muted small">{s.email || ''}</div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  renderRightPanel() {
    const { evaluation, selectedUserId } = this.state;
    if (!selectedUserId) return <div className="text-muted">Selecione um usuário à esquerda</div>;

    return (
      <div>
        <div style={{ maxHeight: '56vh', overflowY: 'auto', paddingBottom: 8 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-start' }}>
            {evaluation.map(ev => {
              const mode = (this.state.inputMode && this.state.inputMode[ev.id]) || 'stars';
              const selected = String(this.state.selectedEvaluationId) === String(ev.id);
              return (
                <div key={ev.id} onClick={() => this.setState({ selectedEvaluationId: ev.id })} style={{ width: 200, padding: 8, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', border: selected ? '2px solid #4f46e5' : '1px solid rgba(0,0,0,0.06)', background: selected ? '#f8fafc' : 'transparent' }}>
                  <div className="d-flex w-100 justify-content-between align-items-start mb-2">
                    <div style={{ flex: 1, textAlign: 'center', fontSize: 14, fontWeight: 600, minHeight: 40 }}>{ev.name}</div>
                    <div style={{ marginLeft: 8 }}>
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleInputMode(ev.id)} title="Alternar entre estrelas e número">{mode === 'number' ? '1..5' : '★'}</button>
                    </div>
                  </div>

                  {mode === 'stars' ? (
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                      <ReactStars
                        key={`stars-${selectedUserId}-${ev.id}`}
                        size={26}
                        count={5}
                        value={this.getScore(selectedUserId, ev.id)}
                        isHalf={false}
                        color="#d1d5db"
                        activeColor="#4f46e5"
                        onChange={(v) => this.handleSaveScore(selectedUserId, ev.id, v, (this.state.selectedEvaluationId === ev.id) ? this.state.observationDraft : undefined)}
                      />
                    </div>
                  ) : (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                      <input
                        key={`num-${selectedUserId}-${ev.id}`}
                        type="number"
                        min={0}
                        max={5}
                        className="form-control text-center"
                        style={{ width: 80 }}
                        value={this.getScore(selectedUserId, ev.id)}
                        onChange={(e) => this.handleNumberChange(ev.id, e.target.value)}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <label className="text-sm font-weight-bold mb-0">Observação</label>
            <div>
              <button type="button" className="btn btn-sm btn-primary" onClick={() => this.saveCurrentObservation()} disabled={this.state.savingObservation}>Salvar observação</button>
            </div>
          </div>
          <textarea className="form-control" rows={6} value={this.state.observationDraft} onChange={(e) => this.setState({ observationDraft: e.target.value })} />
        </div>
      </div>
    );
  }

  render() {
    const ready = this.state.load1 && this.state.load2 && this.state.load3;

    return (
      <Modal isOpen={true} centered size="xl" style={{ minWidth: '1500px', width: '1500px' }} modalClassName="modal-xl">
        <div className="modal-body p-0">
          <Card className="bg-secondary border-0 mb-0">
            <CardHeader className="d-flex align-items-center justify-content-between">
              <div>
                <h6 className="modal-title mb-0">Avaliação da unidade</h6>
                <div className="text-sm text-muted">Unidade: {this.state.unitName || this.props.data?.unit || '-'}</div>
              </div>
            </CardHeader>

            <CardBody>
              {!ready ? (
                <div className="text-center py-5"><ClipLoader color={'#333'} loading={true} /></div>
              ) : (
                <div style={{ display: 'flex', gap: 16 }}>
                  <div style={{ width: 380 }}>
                    <div className="font-weight-bold mb-2">Alunos</div>
                    {this.renderLeftList()}
                  </div>
                  <div style={{ flex: 1 }}>
                    {this.renderRightPanel()}
                  </div>
                </div>
              )}
            </CardBody>

            <CardFooter className="d-flex justify-content-end">
              <Button color="secondary" onClick={() => this.props.close()}>Fechar</Button>
            </CardFooter>
          </Card>
        </div>
      </Modal>
    );
  }
}

export default ModalEvaluation;